import React, { useState, useEffect } from "react";
import "../Principle/Assessts/Styles/PrincipleDashboard.scss";
import { Row, Col } from 'react-bootstrap';
import axios from "axios";
// Below is for import the components
import InternetChecking from "../Student/Reusablecomponents/Network";
import CopyRight from "../Student/Reusablecomponents/Copyright";
import { AssessmentName, NumberToRoman } from "../Student/Reusablecomponents/RegularFunctions";
import NCLOGO from "../Student/Assests/Images/NCLogo.png";


const SchoolParticipation = (props) => {


    const [SGWParticipationR, SetSGWParticipationR] = useState();
    const [Sections, SetSections] = useState();

    const SubjectGradeWiseParticipationReport = async () => {
        await axios.get(process.env.REACT_APP_API_BASE_URL + `/Principal/GetSubjectGradeWiseParticipationReport?SchoolId=${props.schoolId}&ContestCreationId=${props.contestCreationId}&AssessmentType=${props.assessmentType}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                if (res.data[0].grade) {
                    SetSGWParticipationR(res.data);

                    const sections = res.data.reduce((acc, current) => {
                        Object.keys(current).forEach((key) => {
                            if (key.includes('_') && !acc.includes(key.split('_')[0].slice(3))) {
                                acc.push(key.split('_')[0].slice(3));
                            }
                        });
                        return acc;
                    }, []);
                    SetSections(sections);
                } else {
                    SetSGWParticipationR();
                }


            })
            .catch((err) => { console.log(err) })
    };

    useEffect(() => { SubjectGradeWiseParticipationReport(); }, [])

    const GetPColor = (e) => {
        switch (e) {
            case "A":
                return "#3DA663"
            case "B":
                return "#7C60BC"
            case "C":
                return "#3B9ED7"
            case "D":
                return "#F7C66A"
            case "X":
                return "#109CB0"
            default:
                return "#F59E3C"
        }
    };
    const moveLastToFirst = (sub) => {
        if (sub.length > 0) {
            const newItems = [...sub];
            const lastItem = newItems.pop(); // Remove the last item
            newItems.unshift(lastItem); // Add it to the beginning
            return (newItems)
        }
    };
    return (
        <>

<div className="container-fluid Header-Maindiv">

                <Row className="alignitems">
                    <Col ><img src={NCLOGO} alt="Logo" className="LOGO" /> </Col>

                    

                </Row>

            </div>



            <div className="TeacherBgImage dflex flexd-column" style={{height:"88vh"}}>

                <InternetChecking />
                <div className="dflex JSBetween alignitems ">
                    <div className="PrincipleTitle">{AssessmentName(props.assessmentType)}  - Section wise Participation (Grades VI to XII)</div>

                </div>
                {SGWParticipationR ? <>
                    <Row>
                        <Col >
                            <div className="Table-Card mt-2">
                                <table className="Principle-Table">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2" >Grade</th>
                                            {moveLastToFirst(Sections)?.map((Sec, index) => (<th colSpan="3" key={index} style={{ backgroundColor: GetPColor(Sec), color: "#FFF" }}> Section - {Sec}</th>))}
                                        </tr>
                                        <tr >
                                            {moveLastToFirst(Sections)?.flatMap((Sec, Sectionindex) =>
                                                ['Registered', 'Attended', 'Attended%'].map((Attedence, Attendenceindex) => (
                                                    <th key={`Attedence-${Sectionindex}-${Attendenceindex}`} style={{ color: GetPColor(Sec) }} >{Attedence}</th>
                                                )))}
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {SGWParticipationR?.map((item, index) => (
                                            <tr key={index}> <td>{NumberToRoman(item.grade)}</td>
                                                {moveLastToFirst(Sections)?.flatMap((Sec, Sectionindex) => (
                                                    <>
                                                        <td key={`Registrated-${Sectionindex}`} >{item[`sec${Sec}_Registrated`]}</td>
                                                        <td key={`Participated-${Sectionindex}`} >{item[`sec${Sec}_Participated`]}</td>
                                                        <td key={`ParticipatedPercentage-${Sectionindex}`} > {Math.ceil(item[`sec${Sec}_Registrated`] > 0 ? item[`sec${Sec}_Participated`] / item[`sec${Sec}_Registrated`] * 100 : 0)}%</td>
                                                    </>))}
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </Col>


                    </Row>

                    <div className="container-fluid mt-4">
                        <Row>
                            <div className="Notice">
                                <h5>Note</h5>
                                <div>
                                    <ol>
                                        <li><b>Section - X</b> - Students that did not select a section.</li>
                                        <li>Swipe <b>left</b> to see results for <b>Section A and Section B</b>.</li>
                                    </ol>
                                </div>
 
                            </div>
                        </Row>
                    </div>

                    <div className="COpyright-link"><CopyRight /> </div>
                </> : <div className="NoData-Message ">{process.env.REACT_APP_Nodata_Found}</div>}
            </div>
        </>
    )
};

export default SchoolParticipation;